import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

export const HRDashboard = (): ReactElement => {
  return <Outlet />;
};
